import { render, staticRenderFns } from "./MyFaceberryPrintEdit.vue?vue&type=template&id=33511411&scoped=true"
import script from "./MyFaceberryPrintEdit.vue?vue&type=script&lang=js"
export * from "./MyFaceberryPrintEdit.vue?vue&type=script&lang=js"
import style0 from "./MyFaceberryPrintEdit.vue?vue&type=style&index=0&id=33511411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33511411",
  null
  
)

export default component.exports